









































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CHANGE_CASH_ACCOUNT } from '@/modules/listOfAssets/store/cashAccount';
import { CashAccountDetails, ChangeCashAccount } from '@/modules/listOfAssets/types';
import { ApiResponse } from '@/components/types';

const CashAccount = namespace('listOfAssets/cashAccount');

@Component({})
export default class CashAccountDialog extends Vue {
  @Prop({ type: Object, required: true }) account!: CashAccountDetails;

  @CashAccount.Action(CHANGE_CASH_ACCOUNT) changeCashAccount!: (value: ChangeCashAccount) => Promise<ApiResponse>;

  dialog: boolean = false;
  error: any = null;

  value: ChangeCashAccount = {
    finance_account_id: this.account.id,
    list_of_assets_id: this.account.listOfAssetsId,
    note: this.account.note
  };

  @Watch('dialog')
  watchDialogClosed(dialog: boolean) {
    if (dialog) {
      this.value = {
        finance_account_id: this.account.id,
        list_of_assets_id: this.account.listOfAssetsId,
        note: this.account.note
      };

      return;
    }

    setTimeout(() => {
      this.error = null;

      // @ts-ignore
      this.$refs.form.reset();
    }, 200);
  }

  save() {
    this.error = null;

    return this.changeCashAccount(this.value);
  }
}
